import {Pinia} from 'pinia'
import {RouteLocationNormalized} from 'vue-router'
import {useAuthStore} from '@toolify/client/src/stores/AuthStore/useAuthStore'
import {EntityType} from '@toolify/server/src/services/EntityService/enum/EntityType'
import {IUserResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IUserResponseInstance'
import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'

export function ensureSuperAdminRouterHookFactory(pinia: Pinia) {
  return function ensureSuperAdminRouterHook(to: RouteLocationNormalized) {
    if (!to.meta?.requireSuperAdmin) {
      return
    }

    const authStore = useAuthStore(pinia)
    const currentUser = authStore.currentEntity?.entityType === EntityType.User
      ? (authStore.currentEntity.payload as IUserResponseInstance)
      : null

    if (currentUser?.isSuperAdmin) {
      return
    }

    const workspaceName = to.params.workspaceName as string | undefined
    if (workspaceName) {
      return {
        name: RouteName.WorkspaceHome,
        params: {
          workspaceName,
        },
      }
    }

    return {
      name: RouteName.ChooseWorkspace,
    }
  }
}

